import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const filterList = definePartsStyle({
  root: {
    w: "full",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  container: {
    border: "1px solid transparent",
    borderRadius: "8px",
    overflow: "hidden",
    _expanded: {
      borderColor: "transparent.white.05",
    },
  },
  button: {
    w: "full",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    p: "8px",
    borderRadius: "8px",
    _hover: {
      background: "transparent.white.05",
    },
  },
  panel: {
    px: 0,
    pb: 0,
    pt: 0,
  },
});

export const accordionTheme = defineMultiStyleConfig({
  variants: {
    filterList,
  },
});
